export const getExt = (filename) => {
  const idx = filename.lastIndexOf('.');
  // handle cases like, .htaccess, filename
  return idx < 1 ? '' : filename.substr(idx + 1).toUpperCase();
};
